import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Terrain from './Terrain';
import Spieler from './Spieler';
import { szene, lader } from './index';

interface SpawnBereich {
	minX: number,
	maxX: number,
	minY: number,
	maxY: number,
	minZ: number,
	maxZ: number
}
export default class ÄpfelSpawner {
	// Attribute
	public spawnwahrscheinlichkeit = 0.1;
	public äpfelListe: Array<THREE.Object3D> = []
	private apfelFarbe = 'red'
	private apfelGröße = 1;
	private apfel: null | THREE.Object3D = null;
	private lader = new GLTFLoader();
	private kreeireApfel = () => {
		lader.load('./texturen/apfel-model/apfel.glb', (apfelModel) => {
			this.apfel = apfelModel.scene.children[0];
			this.apfel.scale.set(this.apfelGröße / 10, this.apfelGröße / 10, this.apfelGröße / 10);
		}, undefined, (fehler) => {
			console.error(fehler);
			// Nutze Roten Kreis als Apfel, falls Apfel Model nicht lädt
			this.apfel = new THREE.Mesh(new THREE.SphereGeometry(this.apfelGröße, 16, 16), new THREE.MeshBasicMaterial({color: 'red'}));
		});
	}
	// Spawnbereich
	public spawnBereich: SpawnBereich;
	// Für den Raycaster
	private spawnBereichBlockDicke: number;
	// Punktezahl
	private punkteZahlVeränderer: Function;
	constructor(terrainBereich: Terrain, punkteZahlVeränderer: Function) {
		this.spawnBereich =  this.erstelleSpawnBereich(terrainBereich);
		this.spawnBereichBlockDicke =  terrainBereich.dicke;
		this.punkteZahlVeränderer = punkteZahlVeränderer;
		this.kreeireApfel();
	}

	erstelleSpawnBereich(terrainBereich: Terrain) {
		return {
			minX: -terrainBereich.seitenAbstand + this.apfelGröße,
			maxX: terrainBereich.breite - terrainBereich.seitenAbstand - this.apfelGröße,
			minY: -terrainBereich.seitenAbstand + this.apfelGröße,
			maxY: terrainBereich.höhe - terrainBereich.seitenAbstand - this.apfelGröße,
			minZ: -terrainBereich.seitenAbstand + this.apfelGröße,
			maxZ: terrainBereich.dicke - this.apfelGröße
		}
	}
	async spawneApfel() {
		// Finde Spawnort
		const spawnOrt = this.findeLehrenPlatz();
		const apfel = this.apfel!.clone(true);
		apfel.matrixAutoUpdate = false;
		// Rotiert den Apfel in eine zufällige Richtung
		apfel.up.set(Math.random(), Math.random(), Math.random());
		apfel.position.copy(spawnOrt);
		szene.add(apfel);
		apfel.updateMatrix();
		this.äpfelListe.push(apfel);
	}

	findeLehrenPlatz() {
		let spawnOrt = new THREE.Vector3();
		const raycaster = new THREE.Raycaster();
		raycaster.far = this.spawnBereichBlockDicke;
		while (true) {
			// Generiere zufälligen Punkt mithilfe von https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math#returning_a_random_integer_between_two_bounds
			spawnOrt.copy(new THREE.Vector3(Math.floor(Math.random() * (this.spawnBereich.maxX - this.spawnBereich.minX + 1)) + this.spawnBereich.minX, Math.floor(Math.random() * (this.spawnBereich.maxY - this.spawnBereich.minY + 1)) + this.spawnBereich.minY, Math.floor(Math.random() * (this.spawnBereich.maxZ - this.spawnBereich.minZ)) + this.spawnBereich.minZ));
			// Schieße einen Strahl, um zu gucken, dass kein Objekt auf diesem Punkt ist
			raycaster.set(spawnOrt, new THREE.Vector3(0, 0, 1).add(spawnOrt));

			const objekteAufSpawnOrt = raycaster.intersectObjects(szene.children, true);
			// Höre auf Orte zu generieren, wen generierter Ort auf keinem Objekt liegt
			if(!objekteAufSpawnOrt.length) {
				break;
			}
		}
		return spawnOrt;
	}

	verarbeiteKollissionenMitSpieler(spieler: Spieler, spieleAudio: Function) {
		// Nur kollissionen überprüfen, wenn es Äpfel gibt
		if(!this.äpfelListe.length) {
			return;
		}
		// Gucke für jedes Schlangenblock, ob sie ein Apfel berühren
		spieler.blockListe.map((spielerBlock) => {
			const spielerBox = new THREE.Box3().setFromObject(spielerBlock.mesh);
			for(let i = 0; i < this.äpfelListe.length; i++) {
				const apfelBox = new THREE.Box3().setFromObject(this.äpfelListe[i]);
				if(spielerBox.intersectsBox(apfelBox)) {
					spieler.fügeBlockHinzu();
					// Entferne Apfel
					szene.remove(this.äpfelListe[i]);
					this.äpfelListe.splice(i, 1);
					this.punkteZahlVeränderer(1);
					spieleAudio();
				}
			}
		});
	}

	rotiereÄpfel() {
		this.äpfelListe.map((apfel) => {
			apfel.rotation.x += 0.01;
			apfel.rotation.y -= 0.01;
			apfel.rotation.z += 0.01;
			apfel.updateMatrix()
		});
	}
}